const biomedicalImagingRouterPaths = {
  root: '/biomedical-imaging',
  details: '/biomedical-imaging/:namespace/:groupId',
  overview: '/biomedical-imaging/:namespace/:groupId/overview',
  preview: '/biomedical-imaging/:namespace/:groupId/preview',
  sharing: '/biomedical-imaging/:namespace/:groupId/sharing',
  settings: '/biomedical-imaging/:namespace/:groupId/settings',
  contents: '/biomedical-imaging/:namespace/:groupId/contents',
  metadata: '/biomedical-imaging/:namespace/:groupId/metadata',
  activity: '/biomedical-imaging/:namespace/:groupId/activity',
};

export default biomedicalImagingRouterPaths;
